import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1a8e914a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "tag-set-wrapper" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["placeholder"];
import { ref, watch, nextTick, computed } from "vue";
import { maskTagsBasedOnUserRole, removeTag, isInternal, } from "src/shared/Tags";
import { useFocus } from "@vueuse/core";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TagSet',
    props: {
        tags: {},
        readonly: { type: Boolean, default: false },
        isFocused: { type: Boolean, default: false },
        tagInput: {},
        withSuggestions: { type: Boolean, default: false },
        placeholder: { default: "+ New Tag" },
        bordered: { type: Boolean },
        size: { default: "small" }
    },
    emits: ["update:tags", "update:isFocused", "update:tagInput", "tagSelected", "tagTyped"],
    setup(__props, { emit: __emit }) {
        const inputValue = ref("");
        const inputVisible = ref(false);
        const target = ref(null);
        const props = __props;
        const emit = __emit;
        const tagsProxy = computed({
            get() {
                return props.tags;
            },
            set(newValue) {
                emit("update:tags", newValue);
            },
        });
        const inputValueProxy = computed({
            get: () => {
                if (props.tagInput === undefined) {
                    return inputValue.value;
                }
                return props.tagInput;
            },
            set: (value) => {
                inputValue.value = value;
                emit("update:tagInput", value);
            },
        });
        const select = (tag) => {
            emit("tagSelected", tag);
        };
        const remove = (tag) => {
            focused.value = true;
            nextTick(() => {
                const cloned = [...props.tags];
                removeTag(cloned, tag);
                tagsProxy.value = cloned;
            });
        };
        const { maskedTags } = maskTagsBasedOnUserRole(tagsProxy);
        const { focused } = useFocus(target, {
            initialValue: props.isFocused,
        });
        watch(focused, (newValue, oldValue) => {
            if (oldValue === true && newValue === false) {
                emit("update:isFocused", false);
            }
            if (oldValue === false && newValue === true) {
                emit("update:isFocused", true);
            }
        });
        const handleInputConfirm = () => {
            if (inputValueProxy.value) {
                if (props.withSuggestions) {
                    emit("tagTyped", inputValueProxy.value);
                }
                else {
                    const cloned = [...props.tags];
                    cloned.push(inputValueProxy.value);
                    tagsProxy.value = cloned;
                }
            }
            inputVisible.value = false;
            inputValue.value = "";
        };
        const handleDeleteFromInput = () => {
            if (inputValueProxy.value === "") {
                const lastTag = props.tags[props.tags.length - 1];
                if (lastTag !== undefined) {
                    remove(lastTag);
                }
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(maskedTags), (tag) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["tag-set-wrapper__tag", {
                                'tag-set-wrapper__tag--internal': _unref(isInternal)(tag),
                                bordered: _ctx.bordered,
                                large: _ctx.size === 'large',
                            }]),
                        key: tag
                    }, [
                        _createElementVNode("span", {
                            onClick: _withModifiers(($event) => (select(tag)), ["stop"])
                        }, _toDisplayString(tag), 9 /* TEXT, PROPS */, _hoisted_2),
                        (!_ctx.readonly)
                            ? (_openBlock(), _createElementBlock("i", {
                                key: 0,
                                onClick: _withModifiers(($event) => (remove(tag)), ["stop", "prevent"]),
                                class: "fa-light fa-times"
                            }, null, 8 /* PROPS */, _hoisted_3))
                            : _createCommentVNode("v-if", true)
                    ], 2 /* CLASS */));
                }), 128 /* KEYED_FRAGMENT */)),
                (!_ctx.readonly)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        ref_key: "target",
                        ref: target,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((inputValueProxy).value = $event)),
                        class: _normalizeClass({
                            large: _ctx.size === 'large',
                        }),
                        onKeydown: [
                            _withKeys(handleInputConfirm, ["enter"]),
                            _withKeys(handleDeleteFromInput, ["delete"])
                        ],
                        onBlur: handleInputConfirm,
                        type: "text",
                        placeholder: _ctx.placeholder
                    }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_4)), [
                        [_vModelText, inputValueProxy.value]
                    ])
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
